import { useState } from 'react';
import { forgotPasswordRequest } from '@services/auth/authApi';

// Handles forgot-password submission state and response messages.
function useForgotPassword() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function sendRecoveryEmail(email) {
    // Resets prior UI state before making a new request.
    setError('');
    setSuccess('');
    setIsSubmitting(true);
    try {
      const response = await forgotPasswordRequest({ email });
      setSuccess(response?.message || 'Solicitud procesada correctamente.');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return {
    sendRecoveryEmail,
    isSubmitting,
    error,
    success
  };
}

export default useForgotPassword;
